import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AppConfig } from '@env/app-config';

/** Una coincidencia, tal y como la compone el servidor. */
export interface ResultadoDeBusqueda {
  categoria: string;
  titulo: string;
  subtitulo: string | null;
  extracto: string | null;
  /** Etiqueta corta a la izquierda: el código de la tarea, el SHA corto del commit. */
  insignia: string | null;
  /** Ruta del frontend a la que lleva el resultado. */
  enlace: string;
  entidad: string;
  entidadId: number;
}

export interface GrupoDeResultados {
  categoria: string;
  resultados: ResultadoDeBusqueda[];
}

/**
 * La búsqueda global del producto.
 *
 * <p><b>Por qué en `shared/services` y no en una librería de feature.</b> La paleta se abre desde
 * cualquier pantalla, así que el servicio no puede vivir dentro de ninguna: una librería de feature
 * que importara otra para buscar ataría las dos sin motivo. Aquí lo alcanzan todas y no depende de
 * ninguna.
 *
 * <p>Los resultados vienen **agrupados y ya formateados** del servidor. Cada módulo decide cómo se
 * lee el suyo —«Tarea: TASK-123 — Proyecto: Portal» para un commit— y la pantalla sólo los pinta;
 * si viajaran en crudo, este servicio tendría que conocer el modelo de datos de seis módulos.
 */
@Injectable({ providedIn: 'root' })
export class GlobalSearchService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${AppConfig.apiUrl}/api/nexus/search`;

  /** Por debajo de esto el servidor devuelve vacío; se respeta aquí para no hacer el viaje. */
  static readonly MINIMO_CARACTERES = 2;

  buscar(consulta: string): Observable<GrupoDeResultados[]> {
    return this.http.get<GrupoDeResultados[]>(this.apiUrl, {
      params: new HttpParams().set('q', consulta),
    });
  }
}
